<template>
  <v-layout
	column>
    <v-flex 
			xs4
			pl-1
			pr-1		
			pt-4
			mt-5
			mb-2>
      <panel title="User Information">
        <v-text-field
		  v-model="currentUserBio.email"	  
          label="Email Address"
		  readonly
        />
		
		<v-text-field
          :rules="[required]"
          v-model="currentUserBio.name"
          label="Name"
          required
        />
        <v-text-field
          v-model="currentUserBio.phone"
          label="Phone"
        />
      <div
        v-if="error"
        class="danger-alert"
      >
        {{ error }}
      </div>
      <v-btn
			 :color="strongColor"
        dark
        @click="save"
      >
        Update My Information
      </v-btn>
        <div
		  v-if="saveSuccess"
          v-html="saveMessage"
        />


      </panel>
    </v-flex>
		<v-flex
		xs4
		mb-4
		pb-4
		pl-1
		pr-1>
      <panel title="Change Password">
       <form
	   autocomplete="off">
	   
	    <v-text-field
          v-model="currentUser.password"
          label="Current Password"
		  type="password"
		    autocomplete="new-password"
          required
        />
        <v-text-field
          v-model="currentUser.newPassword"
          label="New Password"
		   type="password"
		   autocomplete="new-password"
		   required
        />
        <v-text-field
          v-model="currentUser.newPassword2"
					label="Re-enter New Password"
					type="password"
					 autocomplete="new-password"
					required
        />
		</form>
		<v-btn
			:color="strongColor"
			dark
			@click="updatePassword"
			>
			Change My Password
		</v-btn>
        <div
          class="danger-alert"
          v-html="errorPasswordPanel"
        />
      </panel>
    </v-flex>
  </v-layout>
</template>

<script>
import UsersService from '@/services/UsersService'
import AuthenticationService from '@/services/AuthenticationService'
import { STRONG_COLOR } from "@/components/globals/consts"
import {mapState} from 'vuex'
export default {
	data () {
		return {
			currentUser: {
				// name: null,
				// phone: null,
				// email: null,
				userId: this.$store.state.route.params.userId,
				password: null,
				newPassword: null,
				newPassword2: null // user login
			},
			currentUserBio: {
				name: null,
				phone: null,
				email: null,
				userId: this.$store.state.route.params.userId
			},
			saveSuccess: false,
			saveMessage: null,
			error: null,
			errorPasswordPanel: null,
			required: (value) => !!value || 'Required.',
			strongColor: STRONG_COLOR
		}
	},
	computed: {
		...mapState([
			'isUserLoggedIn',
			'user',
			'route'
		])
	},
	async created () {
		const userId = this.$store.state.route.params.userId
		const currentUser = (await UsersService.show(userId)).data
		if (currentUser) {
			this.currentUserBio.email = currentUser.email
			this.currentUserBio.name = currentUser.name
			this.currentUserBio.phone = currentUser.phone 
		}
	},
	async mounted () {
		if (!this.isUserLoggedIn) {
			this.$router.push({
				name: 'login'
			})
		}
	},
	methods: {
		async save (req, res) {
			this.error = null
			// const userId = this.$store.state.route.params.userId
			try {
				let success = await UsersService.put(this.currentUserBio)
				if (success) {
					this.saveSuccess = true
					this.saveMessage = 'User Information Saved'
				}
				// this.$router.push({
				// 	name: 'clients'
				// })
			} catch (err) {
				console.log(err)
			}
		},
		async updatePassword (req, res) {
			this.error = null

			const userId = this.$store.state.route.params.userId

			if (this.currentUser.password == null) {
				this.errorPasswordPanel = 'Current password cannot be blank.'
			}
			else if (this.currentUser.newPassword2  == null || this.currentUser.newPassword == null) {
				this.errorPasswordPanel = 'New password cannot be blank.'
			}
			else if (this.currentUser.newPassword === this.currentUser.password) {
				this.errorPasswordPanel = 'New password cannot be the same as current password.'
			}
			else if (this.currentUser.newPassword !== this.currentUser.newPassword2) {
				this.errorPasswordPanel = 'New passwords do not match.'
			}
			else if (this.currentUser.newPassword.length < 8) {
				this.errorPasswordPanel = 'Password must be at least 8 characters.'
			}
			else if ((this.currentUser.newPassword === this.currentUser.newPassword2) & this.currentUser.newPassword.length > 7){			
				try {
						const success = await AuthenticationService.changePassword(this.currentUser)
						if (success) {
							this.$router.push({
								name: 'password-changed'
							}) 
						}
				} catch (err) {
					this.errorPasswordPanel = err.response.data.error

				}
			} 
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/EditMe.vue